import { Component, ElementRef, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { ComboBoxComponent } from '@progress/kendo-angular-dropdowns';
import { NumericTextBoxComponent } from '@progress/kendo-angular-inputs';
//import { formComponentMapOptions } from '~/front-models/form-component-map';
import { ComponentBase } from '~/infrastructure/component-base';
import { StockItemListingWithKitDetails, StockItemSummary } from '~/models/modules/item';
import { AccountsService } from '~/services/administration.ts/accounts';
import { AccountsDropdownComponent } from '~/shared/components/accounts-dropdown/accounts-dropdown.component';
import { BarcodeGeneratorsService } from '~/services/modules/stocks/barcode-generators';
import { GridFieldsService } from '~/services/modules/stocks/gridField';
import { StockItemsService } from '~/services/modules/stocks/items';
import { LocationsService } from '~/services/modules/stocks/locations';
import { ThemeManagerService } from '~/services/theme-manager';
import { GridLayoutManagerService } from '~/shared/components/grid/layout/grid-layout-manager';
import { LayoutManagerService } from '~/shared/components/layout/layout-manager';
import { LayoutComponent } from '~/shared/components/layout/layout.component';
import { PageState } from '~/shared/enums/stock-files.enum';
import { UserSummary } from '~/models/administration/user';
import { SecurityService } from '~/services/security.service';
import { AssembleTransactionsService } from '~/services/modules/stocks/assemble-transactions';
import { AssembleTransaction } from '~/front-models/transactionGrid';
import { FormatService } from '~/services/administration.ts/format';
import { TransactionDateEditingService } from '~/services/modules/stocks/administration/transaction-date-editing';
import { DateInputCustomFormatPlaceholder } from '@progress/kendo-angular-dateinputs';
import { QuantityFormatsService } from '~/services/administration.ts/quantity-formats';
import { LocationSummary } from '~/models/modules/location';
import { GridFieldSummary } from '~/models/modules/gridField';
import { DataWithPagingMetadata } from '~/infrastructure/paging';
import { Observable } from 'rxjs';
import { FormatTypes } from '~/shared/enums/FormatTypes';
import { EnvironmentLoaderService } from '~/services/BackEndURL/environment-loader.service';
import { guid } from '@progress/kendo-angular-common';
import { SharedService } from '~/services/sharedService';
import { PageNames } from '~/models/pageNames';

@Component({
    selector: 'app-stock-kitting',
    templateUrl: './kitting.html',
    styleUrls: ['./kitting.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class StockKittingComponent extends ComponentBase implements OnInit {
  page: string = PageNames.KittingTransactions;
  title: string = 'Kitting';
  showTextBox = false;

  _costFormat: string;
  _currentUser: UserSummary;
  _theme: string;
  _form: FormGroup;
  _barcodePopupForm: FormGroup;
  _barcodePopupFormFields: any = [];
  _invalidForm: boolean;
  _model: any;
  _selectedAccount = new FormControl();
  _sortingSelected = new FormControl('old');
  _defaultQuantity = new FormControl();
  _autoCodeGeneration = new FormControl();
  _inventoryCode = new FormControl();
  _quantity = new FormControl();
  _cost = new FormControl();
  _expirationDate = new FormControl();
  _transactionNotes = new FormControl();
  _sites: any[];
  _sitesFiltered: any[];
  _locations: any[];
  _locationsFiltered: any[];
  _items: any[];
  _itemsFiltered: any[];
  _inventoryGridData: any[] = []; //create Kitting Transaction class for the grid
  _itemType: 'standard' | 'batch' | 'serial' | 'serial-with-quantity' | 'non-inventory';
  _barcodePopupActive: boolean;
  _minDate: Date = new Date(1901, 1, 1);
  transactionId: number;
  _selectedCallback = (args: { dataItem: any; }) => args.dataItem;
  _itemFilter: string;
  _addClassActive: boolean = false;
  _selectedAssembly = new FormControl();
  _selectedLocation = new FormControl();

  _selectedSubstitute = new FormControl();

  _datePickerFormat: string;
  _dateLabelFormat: DateInputCustomFormatPlaceholder = { year: 'YYYY', month: 'MM', day: 'DD', hour: '', minute: '', second: '' }

  _dateEnabled: boolean;

  _dialogComponentName: string;
  _isDialiog: boolean = false;
  _dialogModel: any;

  quantityFormat: string;
  digitNumber: number;


  isGeneralInformationExpanded: boolean = true;

  isAssemblyMoreAvaialability: boolean = false;
  lessAvailabaleQuantity: number = 0;
  assembleQuantity: number = 0;

  _selectInevtoryIdsPopup: boolean;

  _selectedSeriaslListIds: any[];
  _selectedSeriaslGridIds: any[];


  _serialItemSelected: any[] = [];

  isSubstitute: boolean = false;

  _currentSiteId: number;
  _currentItemAdded: any;

  _currentLocationAdded: any;

  _showLocationsGrid: boolean = false;

  _selectedLocations: LocationSummary[] = [];
  _locationsGridColumns: GridFieldSummary[];

  _showStocksGrid: boolean = false;
  _selectedStocks: StockItemSummary[] = [];
  _stockItemsGridColumns: GridFieldSummary[];

  @ViewChild('quantity_input') quantityInput: NumericTextBoxComponent;
  @ViewChild('cost_input') costInput: NumericTextBoxComponent;
  @ViewChild('kendo_combo_locations') kendoComboLocations: ComboBoxComponent;
  @ViewChild('Kendo_Input_Transaction_note') KendoInputTransactionnote: ElementRef;
  @ViewChild('Kendo_Input_Notes') KendoInputNotes: ElementRef;
  @ViewChild('kendo_combo_accounts') kendoComboAccounts: AccountsDropdownComponent;
  @ViewChild('kendo_combo_sites') kendoComboSites: ComboBoxComponent;
  @ViewChild('kendo_combo_assembly') kendoComboAssembly: ComboBoxComponent;
  costPriceFormatType: FormatTypes = FormatTypes.CostandPriceFormat;
  quantityFormatType: FormatTypes = FormatTypes.QuantityFormat;
  _showStockItemFileNotes: boolean = false;
  _stockItemNotesModel: StockItemSummary;
  constructor(
    private _fb: FormBuilder,
    private _themeManager: ThemeManagerService,
    private _accountsService: AccountsService,
    private _locationsService: LocationsService,
    private _assembleTransactionsService: AssembleTransactionsService,
    private _stockItemsService: StockItemsService,
    private _barcodeGeneratorsService: BarcodeGeneratorsService,
    private _layoutComponent: LayoutComponent,
    private _layoutManager: LayoutManagerService,
    private _gridLayoutManagerService: GridLayoutManagerService,
    private _gridFields: GridFieldsService,
    private _sharedService: SharedService,
    private _securityService: SecurityService,
    private _formatService: FormatService,
    private quantityFormatsService: QuantityFormatsService,
    private _TransactionDateEditting: TransactionDateEditingService
  ) {
    super();
    this._themeManager.themeChange.subscribe((data) => {
      this._theme = data;
    });

    this.LoadData();

    this._gridFields
      .getGridFieldsByPage('stockItems')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('stockItems', data);
      });

    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('stockItems', (gridColumns) => {
      this._stockItemsGridColumns = gridColumns;
    }));
    this._currentUser = this._securityService.currentUser;

    this._gridFields
      .getGridFieldsByPage('locations')

      .subscribe((data: any) => {
        this._gridLayoutManagerService.setGridColumnSubjects('locations', data);
      });
    this.registerSubscription(this._gridLayoutManagerService.subscribeToColumnsChanges('locations', (gridColumns) => {
      this._locationsGridColumns = gridColumns;
    }));



  }



  async LoadData() {
    this.quantityFormat = await this.quantityFormatsService.getQuantityFormatForNumericTextBox();
    this.digitNumber = await this.quantityFormatsService.getDigitNumber(this.quantityFormat);
  }
  closeTextbox(event: any) {
    //this.title=event.value;
    this._gridFields.EditPageTitle(this.page, event.value).subscribe((data: any) => {
      this.title = data.titleName;
      this._sharedService.TitleChanged.emit(true);
    });
    this.showTextBox = false;
  }
  showTextbox() {
    this.showTextBox = true;
    //document.getElementById('titleTextBox').focus();
    //this.titleTextBox.nativeElement.focus();
  }

  ngOnInit() {
    this._gridFields.getPageByName(this.page).subscribe((data) => {
      if (data.titleName) {
        this.title = data.titleName;
      }
    });


    this._initForm();
    this._OpenAccount();
    setTimeout(() => {
      this._currentSiteId = this._form.get('site').value
      this._loadItemsDD(this._currentSiteId);
      this._loadLocationsDD(this._form.get('site').value);
    });

    this._selectedAssembly.valueChanges.subscribe((x) => {
      if (x) {
        setTimeout(() => {
          this.kendoComboLocations.toggle(true);
          this.kendoComboLocations.focus();
        });
      }
    });

    this._selectedLocation.valueChanges.subscribe((x) => {
      if (x) {
        // setTimeout(() => {
        //     this.quantityInput.focus();
        // });
      }
    });

    /** Format */
    this._datePickerFormat = this._formatService.dateFormat;
    this._costFormat = this._formatService.costFormatValue;
    this.getDateEnabledOption();

    this._stockItemsService.isAddKitting.subscribe((x) => {
      this._currentItemAdded = x;
      this._loadItemsDD(this._currentSiteId);
    });

    this._locationsService.locationAdded.subscribe((x) => {
      this._currentLocationAdded = x;
      this._loadLocationsDD(this._currentSiteId);
    });
  }
  _OpenAccount() {
    if (this._currentUser.isEnterprise) {
      setTimeout(() => {
        this.kendoComboAccounts.toggle(true);
        this.kendoComboAccounts.focus();
      });
    }
    else {
      setTimeout(() => {
        this.kendoComboAssembly.toggle(true);
        this.kendoComboAssembly.focus();
      });
    }
  }
  _onStateChanges(e: any) {
    if (e === 'minimized') {
      this._layoutManager.removeOverlay();
    } else {
      this._layoutManager.applyOverly();
    }
  }

  ngOnDestroy() {
    this._layoutManager.removeOverlay();
  }

  _skipTransactionNotes() {
    let TransactionNotes = this.KendoInputTransactionnote;
    TransactionNotes.nativeElement.classList.remove('focusedInput');
    TransactionNotes.nativeElement.blur();
    this._addClassActive = true;
  }
  _focustransactionNotes() {
    let TransactionNotes = this.KendoInputTransactionnote;
    TransactionNotes.nativeElement.classList.add('focusedInput');
    this._addClassActive = false;
  }
  _focusOutTransactionNotes() {
    setTimeout(() => {
      let TransactionNotes = this.KendoInputTransactionnote;
      TransactionNotes.nativeElement.classList.remove('focusedInput');
    }, 200);
  }


  ExpandCollapseGeneralInfoWidget(isExpand: boolean) {
    this.isGeneralInformationExpanded = !isExpand;
  }

  _focusNotes() {
    let Notes = this.KendoInputNotes;
    Notes.nativeElement.classList.add('focusedInput');
    this._addClassActive = false;
  }
  _focusOutNotes() {
    setTimeout(() => {
      let Notes = this.KendoInputNotes;
      Notes.nativeElement.classList.remove('focusedInput');
    }, 200);
  }
  _skipNotes() {
    let Notes = this.KendoInputNotes;
    Notes.nativeElement.classList.remove('focusedInput');
    Notes.nativeElement.blur();
    this._addClassActive = true;
  }

  _generateBarcodeClick() {
    this.runGenerateBarcode();
    if (this._itemType == 'serial') {
      setTimeout(() => {
        this._initBarCodePopupForm();
      }, 500);
    } else if (this._itemType == 'batch') {
      // this.expirationDateInput.focus();
    }

  }
  _getStockItems = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    if (model != null && model.filter != null && this._form.get('site').value != null) {
      //model.SiteId = this._form.get('site').value;
      model.iskit = true;
      return this._stockItemsService.getStockItems(params, model, this._form.get('site').value);
    }
  }

  _handleSitesFilter(value: any) {
    this._sitesFiltered = this._sites.filter(
      (s) => s.name.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _getLocations = (params?: any, model?: any): Observable<DataWithPagingMetadata<any>> => {
    if (model != null && model.filter != null) {

      return this._locationsService.getLocations(params, model, this._form.get('site').value);
    }
  }


  _loadLocationsDD(siteId: number) {
    //return this._locationsService.getLocationListingBySite(siteId)
    let siteModel = {
      siteId: siteId
    }
    return this._locationsService.getLocationsByAccounts(siteModel)
      .subscribe((data: any) => {
        this._locations = data;
        this._locationsFiltered = data;
        if (this._currentLocationAdded)
          this._selectedLocation.setValue(this._currentLocationAdded);
      });
  }

  _handleLocationsFilter(value: any) {
    this._locationsFiltered = this._locations.filter(
      (s) => s.code.toLowerCase().indexOf(value.toLowerCase()) !== -1
    );
  }

  _loadItemsDD(siteId: number) {
    return this._stockItemsService.getStockItemsListingBySiteWithKitDetails(siteId)
      .subscribe((data: any) => {
        this._items = data.body;
        this._itemsFiltered = data.body;
        if (this._currentItemAdded)
          this._selectedAssembly.setValue(this._currentItemAdded);
      });
  }

  _handleItemsFilter(value: any) {
    this._itemFilter = value;
    this._itemsFiltered = this._items.filter((item) => {
      return (item.number.toString().toLowerCase().indexOf(value.toLowerCase()) > -1 ||
        item.description?.toLowerCase().indexOf(value.toLowerCase()) > -1 ||
        item.itemType.name.toLowerCase().indexOf(value.toLowerCase()) > -1);
    })
  }


  _handleItemsChange(value: any) {
    if (value != null) {
      this._onClear();
      this._itemType = this.getItemType(value.itemType.name);
      this.isAssemblyMoreAvaialability = false;
      this._inventoryCode.setValue(value.number);

    }
  }

  assemblyFillGrid() {
    this._quantitySubmitted();
    if (this._selectedAssembly.value && this._quantity.value > 0) {
      setTimeout(() => {
        this.fillGrid();
      }, 500);
    }
  }
  _quantitySubmitted() {
    //this._inventoryGridData = [];
    this._selectedSubstitute = null;
    this.isAssemblyMoreAvaialability = false;
    this.lessAvailabaleQuantity = 0;
    this._generateBarcodeClick();

  }

  _onSave(e: any) {
    if (!this._inventoryGridData.length) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'No items to assemble. Transaction was not successfull.',
        withoutConfirm: true
      });
    } else if (!this.checkInventoriesValiation() || !this._selectedAssembly.value ||
      !this._selectedLocation.value || !this._inventoryCode.value) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Please fill the required fields in the grid.',
        withoutConfirm: true
      });

      // } else if (this._form.invalid) {
      //     this._invalidForm = true;
      //
    }
    else {
      this._invalidForm = false;
      this._form.value.cost = this._cost.value ?? 0;
      this._form.value.expirationDate = this._expirationDate.value;
      this._form.value.location = this._selectedLocation.value;
      this._form.value.selectedStock = this._selectedAssembly.value;
      this._form.value.quantity = this._quantity.value;
      this._form.value.selectedInentories = this._inventoryCode.value;


      const formModel = this._form.value;
      let model: any = {};
      model['entryDate'] = formModel.date ?? this._form.get('date')?.value;
      model['siteId'] = formModel.site;
      model['locationId'] = formModel.location.id;
      model['quantity'] = formModel.quantity;
      model['cost'] = formModel.cost;
      model['stockItemId'] = formModel.selectedStock.id;
      model['locationId'] = formModel.location.id;
      model['expirationDate'] = formModel.expirationDate;

      model['inventoryNumber'] = formModel.selectedInentories;

      model['notes'] = formModel.notes;

      model['itemTypeId'] = formModel.selectedStock.itemType.id;
      if (formModel.selectedStock.itemType.id == 2)
        model['seriaInventories'] = formModel.selectedInentories.split(',');


      model['stockAssembleTransactionDetails'] = this._inventoryGridData.map((x) => {
        return {
          id: 0,
          stockAssembleTransactionId: 0,
          locationId: x.selectedFromLocation?.locationId,
          stockLocationId: x.selectedFromLocation?.stockLocationId,
          issueQuantity: x.qtyIssued,
          issueCost: x.stockItemInfo?.costInfo?.cost,
          issuePrice: x.stockItemInfo?.costInfo?.fixedUnitPrice,
          StockItemId: x.stockItemId,
          inventoryNumber: x.inventoryNumber,
          serialOrBatchInventories: x.selectedInvIdsList,
          notes: ""
        };
      });
      this._assembleTransactionsService
        .createAssemble(model)

        .subscribe((data: any) => {
          this.transactionId = parseInt(data.message)
          var msg = "";
          if (data != null && data.message != null) {
            this._loadItemsDD(this._currentSiteId);
            this._onClear();
            msg = 'Kitting Transaction # ' + data.message + ' has been processed successfully.';
          } else {
            msg = 'Error';
          }
          this._layoutComponent.openPopup({
            title: 'Alert',
            message: msg,
            returnAfterOkCloseClick: true,
            withoutConfirm: true
          });
          this._onclearWithAssembly();
          this._OpenAccount();
        });
    }
  }

  _removeHandler({ sender, dataItem }: any) {
    //this._inventoryGridData = this._inventoryGridData.filter((x: any) => x.itemNumber != dataItem.itemNumber);
    this._inventoryGridData = this._inventoryGridData.filter((x: any) => x.rowId != dataItem.rowId);
  }

  _onQuantityChange(e: any, item: AssembleTransaction) {
    item.quantity = e;

    if (item.itemType === 'serial') {
      this.generateBarcode(e)
        .subscribe((data: any) => {
          item.inventoryCode = data.result.toString();
        });
    }
  }

  _onInventoryCodeChange(e: any, item: AssembleTransaction) {
    item.inventoryCode = e;
  }

  _onExpirationDateChange(e: any, item: AssembleTransaction) {
    item.expirationDate = e;
  }

  _selectLocationsHandler(): void {
    this._showLocationsGrid = true;
  }

  _closeLocationsWindow(): void {
    this._showLocationsGrid = false;
  }
  _returnSelectedLocationsHandler(e: any[]): void {

    this._showLocationsGrid = false;
    this._selectedLocation.setValue(this._selectedLocations[0])
    // this._selectedLocations.forEach((item: LocationSummary) => {
    //     this._form.controls.location.setValue(item);
    // });

  }
  _selectStocksHandler(): void {
    this._showStocksGrid = true;
  }
  _closeStocksWindow(): void {
    this._showStocksGrid = false;
  }
  _onStockRowSelectionChanges(e: any[]) {
    this._selectedStocks = [];
    // e.forEach((item) => {
    //     this._selectedStocks.push(item);
    // });
    var selectedItem = this._itemsFiltered.find((x: any) => x.id == e[0].id)
    this._selectedStocks.push(selectedItem);

  }
  _returnSelectedStocksHandler(e: any[]): void {

    this._showStocksGrid = false;
    this._selectedAssembly.setValue(this._selectedStocks[0]);

  }
  //#en

  _onLocationRowSelectionChanges(e: any[]) {
    this._selectedLocations = [];
    e.forEach((item) => {
      this._selectedLocations.push(item);
    });
  }

  _openForm(componentName: string) {
    this._isDialiog = true;
    this._dialogComponentName = componentName;
    this._dialogModel = { model: {}, pageState: PageState.ADD, reload: 'model' }
  }

  _closeDialog(event: any) {
    this._isDialiog = event.open;
  }

  _onClear() {
    this.transactionId = null;
    const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? "";
    this._form.setValue({
      date: new Date(),
      site: JSON.parse(loggedInAccountSites)[0].siteId,
      stock: null,
      location: null,
      quantity: 0,
      selectedStock: null,
      selectedInentories: null,
      expirationDate: null,
      cost: 0,
      notes: null
    });

    this._form.value.cost = this._cost.value ?? 0;
    this._form.value.expirationDate = this._expirationDate.value;
    this._form.value.location = this._selectedLocation.value;
    this._form.value.selectedStock = this._selectedAssembly.value;
    this._form.value.quantity = this._quantity.value;

    this._quantity.setValue(null);
    this._cost.setValue(null);
    this._selectedAccount.setValue(null);
    this._expirationDate.setValue(null);
    this._inventoryCode.setValue(null);
    this._inventoryCode.enable();
    this._selectedLocation.setValue(null);
    this._autoCodeGeneration.setValue(null);
    this._defaultQuantity.setValue(null);
    this._inventoryGridData = [];

    //this._OpenAccount();
  }
  _onclearWithAssembly() {
    this._selectedAssembly.setValue(null);
    this._selectedSubstitute = null;
    this._onClear();
  }

  _initBarCodePopupForm() {
    if (!this._barcodePopupActive) {
      let inventoryValues: any[] = [];
      if (this._inventoryCode.value) {
        inventoryValues = this._inventoryCode.value.split(', ');
      }

      let record: any = {};
      for (let i = 0; i < this._quantity.value?.toFixed(this.digitNumber); i++) {
        record['field' + i] = inventoryValues[i] ? [inventoryValues[i],
        Validators.required] : [null, Validators.required];
        this._barcodePopupFormFields.push('field' + i);
      }

      this._barcodePopupForm = this._fb.group(record);
      this._barcodePopupActive = true;
      this._layoutManager.applyOverly();
    }
  }



  _barcodePopupClose() {
    this._barcodePopupFormFields = [];
    this._barcodePopupActive = false;
    this._layoutManager.removeOverlay();
  }



  _onBarcodePopupClear(field?: string) {
    if (field) {
      this._barcodePopupForm.get(field).setValue(null);
    } else {
      this._barcodePopupForm.reset();
    }
  }

  _selectInventoryIdsOpen(event: any, item: any) {

    this._selectInevtoryIdsPopup = true;
    if (item) {
      this._serialItemSelected = [item];
      this._selectedSeriaslListIds = item.selectedInvIds?.map((x: any) => x.inventoryNumber) || [];
    }
  }
  _selectInventoryIdsClose() {

    this._selectInevtoryIdsPopup = false;
    this._layoutManager.removeOverlay();
  }

  _selectInventoryIdsSave(value: any, item: any) {

    let selectedInv = item.selectedFromLocation?.inventories?.
      filter((x: any) => this._selectedSeriaslListIds.includes(x.inventoryNumber));

    let totalInvsQnty = selectedInv?.reduce((acc: any, inv: any) => acc + inv.availability, 0) ?? 0;

    if ((this._selectedSeriaslListIds == undefined || this._selectedSeriaslListIds === null) ||
      (item.qtyIssued > totalInvsQnty && (item.stockItemInfo.itemType.id == 2
        || item.stockItemInfo.itemType.id == 3)) ||
      (item.qtyTransaction > totalInvsQnty && item.stockItemInfo.itemType.id != 2 && item.stockItemInfo.itemType.id != 3)) {
      this._layoutComponent.openPopup({
        title: 'Validation',
        message: 'Total quantity of chosen items should be equal to the quantity needed',
        withoutConfirm: true,
      });
      return false;
    }
    item.selectedInvIds = selectedInv;
    item.selectedInvIdsList = selectedInv;


    this._selectInevtoryIdsPopup = false;
  }
  onItemClick(event: any): void {
    event.preventDefault();
    event.stopPropagation();
    // Prevent the default behavior (toggle) by not handling the event.
  }

  _onBarcodePopupSave() {
    let counter = 0;
    let inventoryCode = '';
    Object.keys(this._barcodePopupForm.controls).forEach(key => {
      if (counter > 0) {
        inventoryCode += ', ';
      }

      let fieldValue = this._barcodePopupForm.get(key).value;
      if (fieldValue) {
        inventoryCode += fieldValue;
      }

      counter++;
    });

    this._inventoryCode.setValue(inventoryCode);
    this._barcodePopupClose();

    //this._quantitySubmitted();
  }

  _barcodePopupGenerateBarcode(field?: string) {
    if (!field) {
      for (const key in this._barcodePopupForm.controls) {
        if (!this._barcodePopupForm.get(key).value) {
          field = key;
          break;
        }
      }
    }

    if (field) {
      this.generateBarcode(1)
        .subscribe((data: any) => {
          this._barcodePopupForm.get(field).setValue(data.result.toString());
        });
    }
  }

  private runGenerateBarcode(item: StockItemSummary = null) {
    let counter = this._itemType === 'serial' ? this._quantity.value?.toFixed(this.digitNumber) : 1;
    this.generateBarcode(counter)
      .subscribe((data: any) => {

        if (this._itemType === 'standard' || this._itemType === 'non-inventory') {
          this._inventoryCode.setValue(this._selectedAssembly.value.number);
        } else
          this._inventoryCode.setValue(data.result.toString());
        if (item != null) {
          if (item.itemType.id == 1) {
            this._expirationDate.setValue(null);
          }
          let gridItem = this._inventoryGridData.find(r => r.itemNumber === item.number);
          if (!this.isAssemblyMoreAvaialability) {
            if (!gridItem) {
              this._inventoryGridData.push({
                rowId: guid(),
                stockItemId: item.id,
                itemNumber: item.number,
                description: item.description,
                quantity: this._quantity.value ? +this._quantity.value?.toFixed(this.digitNumber) : 0,
                uom: item.receiveUnitOfMeasure.code,
                inventoryCode: this._inventoryCode.value,
                expirationDate: this._expirationDate.value,
                unitCost: item.costInfo?.cost,
                itemType: this.getItemType(item.itemType.name),
                itemTypeId: item.itemType.id,
                minQuantity: item.minqty,
                maxQuantity: item.maxqty
              });
            }
          }
        }
      });
  }

  private checkInventoriesValiation(): boolean {
    for (let item of this._inventoryGridData) {
      if (item.itemType === 'standard') {
        if (item.quantity <= 0) {
          return false;
        }
      }

      if (item.itemType === 'non-inventory') {
        if (item.quantity <= 0 || !item.inventoryCode) {
          return false;
        }
      }

      if (item.itemType !== 'non-inventory' && item.itemType !== 'standard') {
        if (item.quantity <= 0 || (!item.selectedInvIdsList && !item.SubstituteItems)) {
          return false;
        }
      }
      if (item.itemType !== 'non-inventory') {
        if (!item.inventoryNumber && (!item.selectedInvIdsList || item.selectedInvIdsList.length === 0)) {
          return false;
        }
      }
      //let itemsNotExists=this._inventoryGridData.filter((x:any)=>!this._ItemsNeededForGrid.includes(x.stockItemId));
      const missingItems = this._ItemsNeededForGrid.filter((element: number) => {
        return this._inventoryGridData.filter((x: any) => element === x.stockItemId).length === 0;
      });

      if (missingItems.length > 0) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Assembly Not Has All its Items!',
          withoutConfirm: true
        });
        return false;
      }

      // if(itemsNotExists)
      // {
      //   this._layoutComponent.openPopup({
      //     title: 'Validation',
      //     message: 'Assembly Not Has All its Items!',
      //     withoutConfirm: true
      // });
      //   return false;
      // }
    }

    return true;
  }

  private getItemType(itemTypeName: string) {
    switch (itemTypeName) {
      case 'Standard':
        return 'standard';
      case 'Serial':
        return 'serial';
      case 'Batch':
        return 'batch';
      case 'Non Inventory':
        return 'non-inventory';
      case 'Serial with Quantity':
        return 'serial-with-quantity';
    }
  }

  private generateBarcode(quantity: number) {

    return this._barcodeGeneratorsService
      .getBarcode('inventories', quantity);
  }

  private _initForm() {
    const loggedInAccountSites = localStorage.getItem('loggedInAccountSites') ?? "";
    this._form = this._fb.group({
      date: [new Date(), Validators.required],
      site: [JSON.parse(loggedInAccountSites)[0].siteId, Validators.required],
      stock: [null, Validators.required],
      location: [null, Validators.required],
      quantity: 0,
      selectedStock: null,
      selectedInentories: null,
      expirationDate: null,
      cost: 0,
      notes: null
    });
    this.getDateEnabledOption();
  }

  _ItemsNeededForGrid: any;
  private fillGrid() {
    if (!this.isAssemblyMoreAvaialability && this._selectedAssembly?.value?.stockItemKitDetails) {
      this.isSubstitute = false;
      this._inventoryGridData = [];
      this._selectedAssembly.value.stockItemKitDetails.forEach((data: StockItemListingWithKitDetails, index: number) => {
        data.stockItem.stockLocations = data.stockItem.stockLocations.filter((x: any) => x.siteId == this._form.controls['site'].value);
        let avaiialbleQnty = data.stockItem?.stockLocations.reduce((acc: any, item: any) => acc + item.availability, 0);


        let quantityTransacction = data.quantity * this._quantity.value?.toFixed(this.digitNumber);

        if ((avaiialbleQnty < quantityTransacction && this.lessAvailabaleQuantity < avaiialbleQnty && index == 0) ||
          (avaiialbleQnty < quantityTransacction && this.lessAvailabaleQuantity > avaiialbleQnty)) {
          this.lessAvailabaleQuantity = avaiialbleQnty;
          this.assembleQuantity = avaiialbleQnty / data.quantity;
          this.isAssemblyMoreAvaialability = true;
        }

        this.isSubstitute = this._selectedAssembly.value.stockItemSubKitDetails.length > 0 ? true : false;
        let isItemExists = this._inventoryGridData.find((x: any) => x.stockItemId == data.stockItem?.id);
        if (!isItemExists) {
          let newItem: any = {
            rowId: guid(),
            stockItemId: data.stockItem?.id,
            itemNumber: data.stockItem?.number,
            stockItemInfo: data.stockItem,
            description: data.stockItem?.description,
            qtyAssembly: data.quantity,
            qtyTransaction: quantityTransacction,
            quantity: 0,
            qtyIssued: 0,
            //QuantityIssue:avaiialbleQnty>quantityTransacction?quantityTransacction:avaiialbleQnty,
            avaiialbleQnty: avaiialbleQnty,
            fromLocationFiltered: data.stockItemLocationsAvailable.filter((x: any) => {
              const invAvailable = x.inventories?.reduce((acc: any, item: any) => acc + item.availability, 0) ?? 0;
              return invAvailable > 0 || Number(x.availability) > 0;
            }),
            SubstituteItemsFiltered: this._selectedAssembly.value.stockItemSubKitDetails?.map(
              (item: any) => item.stockItemKitDetailId == data.id ? item.subDetailStockItem : null
            ).filter((x: any) => x != null),
            SubstituteItems: this._selectedAssembly.value.stockItemSubKitDetails,
            isDisabled: false
          };

          this._inventoryGridData.push(newItem);
          if (newItem.fromLocationFiltered.length == 1) {
            newItem.selectedFromLocation = newItem.fromLocationFiltered[0];
            this._selectedItemLocationChange(newItem.selectedFromLocation, newItem);
          }

          this._ItemsNeededForGrid = this._inventoryGridData.map((x: any) => x.stockItemId);
        }
      });

      if (this.isAssemblyMoreAvaialability) {
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: `You can only build ${Number(this.assembleQuantity).toFixed(this.digitNumber)} from this Assembly`,
          withoutConfirm: true
        });
      }
    }
  }

  currentSelectedLocation: any;
  _selectedItemLocationChange(value: any, item: any) {

    if (!value) {
      item.selectedFromLocation = null;
      item.fromLocationCode = null;
      //this._inventoryGridData.map((x:any)=>item.stockItemId==x.stockItemId? x.)
    }
    else {
      let locationExists = this._inventoryGridData.filter(
        (s) => s.fromLocationCode == value.locationCode && s.stockItemId == item.stockItemId);
      if (locationExists.length == 0) {
        item.isSerialOrBatchOrSrwthquanty = false;
        this._serialItemSelected = [];

        let itemTypeId = item.stockItemInfo?.itemType?.id;

        if (itemTypeId == 2 || itemTypeId == 3 || itemTypeId == 5) {
          item.isSerialOrBatchOrSrwthquanty = true;
          this._serialItemSelected.push(item);
        }

        item.selectedFromLocation = value;
        let invsHasAvalbility = value.inventories.filter((x: any) => x.availability > 0);
        item.selectedFromLocation.inventories = invsHasAvalbility;
        item.fromLocationCode = value.locationCode;

        item.quantity = value?.inventories.reduce((acc: any, item: any) => acc + item.availability, 0);
        item.qtyIssued = item.quantity > item.qtyTransaction ? item.qtyTransaction : item.quantity;

        if (item.quantity < item.qtyTransaction)
        //&& !item.isSerialOrBatchOrSrwthquanty
        {

          this._inventoryGridData.push({
            rowId: guid(),
            stockItemId: item.stockItemId,
            itemNumber: item.itemNumber,
            description: item.stockItemInfo.description,
            quantity: 0,
            uom: item.stockItemInfo.receiveUnitOfMeasure?.code,
            inventoryCode: this._inventoryCode.value,
            expirationDate: this._expirationDate.value,
            unitCost: item.stockItemInfo.costInfo?.cost,
            itemType: this.getItemType(item.stockItemInfo.itemType?.name),
            itemTypeId: item.stockItemInfo.itemType.id,
            minQuantity: item.stockItemInfo.minqty,
            maxQuantity: item.stockItemInfo.maxqty,
            fromLocationFiltered: item.fromLocationFiltered,
            qtyAssembly: item.qtyAssembly,
            qtyTransaction: item.qtyTransaction - item.qtyIssued,
            SubstituteItemsFiltered: this._selectedAssembly.value.stockItemSubKitDetails.map(
              (item: any) => item.subDetailStockItem
            ),
            stockItemInfo: item.stockItemInfo,
            SubstituteItems: this._selectedAssembly.value.stockItemSubKitDetails,
            isDisabled: item.SubstituteItemsFiltered.length > 0 && item.selectedFromLocation != null ? true : false
          });
        }

        if (value.inventories?.length == 1) {
          item.selectedInventory = value.inventories[0];
          this._selectedItemInventoryChange(item.selectedInventory, item);
        }
      }
      else {
        item.selectedFromLocation = null;
        item.fromLocationCode = null;
        this.currentSelectedLocation == null;
        this._layoutComponent.openPopup({
          title: 'Validation',
          message: 'Location Already Chosen!',
          withoutConfirm: true
        });

      }
    }

  }

  _selectedItemInventoryChange(value: any, item: any) {
    //item.quantity = value?.availability ?? 0;
    item.selectedInventory = value;
    item.inventoryNumber = value?.inventoryNumber;
  }

  _changeSubstitute(value: any, item: any) {

    if (value) {
      item.perviousItem = Object.assign({}, item);
      var curItem = item.SubstituteItems.find((x: any) => x.subDetailStockItemId == value?.id);

      //item.itemNumber=value.number;
      item.stockItemInfo = value;
      //item.description=value.description;

      item.stockItemId = value.id;
      item.qtyTransaction = curItem.quantity * this._quantity.value?.toFixed(this.digitNumber);
      item.qtyAssembly = curItem.quantity;
      item.avaiialbleQnty = value.stockLocations.reduce((acc: any, item: any) => acc + item.availability, 0);
      item.fromLocationFiltered = curItem.stockItemLocationsAvailable.filter((x: any) => {
        const invAvailable = x.inventories?.reduce((acc: any, item: any) => acc + item.availability, 0) ?? 0;
        return invAvailable > 0 || Number(x.availability) > 0;
      });

      if (item.fromLocationFiltered.length == 1) {
        item.selectedFromLocation = item.fromLocationFiltered[0];
        this._selectedItemLocationChange(item.selectedFromLocation, item);
      }


    }
    else {
      item.perviousItemNumber = item.perviousItem.itemNumber;

      item.stockItemInfo = item.perviousItem.stockItemInfo;

      item.stockItemId = item.perviousItem.stockItemInfo.id;
      item.qtyTransaction = item.perviousItem.qtyTransaction;
      item.qtyAssembly = item.perviousItem.qtyAssembly;
      item.avaiialbleQnty = item.perviousItem.avaiialbleQnty
      item.fromLocationFiltered = item.perviousItem.fromLocationFiltered;

    }

  }

  _selectedListInventoryChange(value: any, item: any) {
    //item.quantity = value?.availability ?? 0;
    if (value != null) {
      this._selectedSeriaslListIds = value;
      item.selectedInvIds = item.selectedFromLocation?.inventories?.filter((x: any) => value.includes(x.inventoryNumber)) || [];
      item.selectedInvIdsList = item.selectedInvIds;
    }

  }


  getDateEnabledOption() {
    this._TransactionDateEditting.getTransactionDateEditing("get-data")

      .subscribe((x: any) => {
        if (x != null && x != undefined) {
          this._dateEnabled = x.transactionDateEditing;
          if (!this._dateEnabled) {
            this._form.get('date')?.disable();
          }
        }
      })
  }

  //#region Stock Item Fetch All Functions
  getMarkupType(obj: any, propString: any) {

    if (obj.costInfo.isCalculatedPrice)
      return "Calclulated Price"
    else if (obj.costInfo.isFixedPrice)
      return "Fixed Price"
  }
  displayCatImage(input: string, ListOfItems: any = null) {
    let primaryPicture;
    if (ListOfItems != null) {
      primaryPicture = ListOfItems.find((v: any) => v.categoryFilePrimary == true);
      if (primaryPicture != undefined && primaryPicture != null)
        input = primaryPicture.file.thumbnail;
    }
    return EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + input;
  }

  displayStockImage(input: string, ListOfItems: any = null) {
    let primaryPicture;
    if (ListOfItems != null) {
      primaryPicture = ListOfItems.find((v: any) => v.stockitemfileisprimary == true);
      if (primaryPicture != undefined && primaryPicture != null)
        input = primaryPicture.file.thumbnail;
    }

    return EnvironmentLoaderService.envConfig.enterpriseApiLocal + '/' + input;
  }
  _closeStockItemNotesWindow() {
    this._showStockItemFileNotes = false;
  }
  _showStockItemNotesWindow(id: number) {
    this._stockItemsService.getStockItem(id)

      .subscribe((model: any) => {
        this._stockItemNotesModel = model;
        this._showStockItemFileNotes = true;
      });
  }
  getAccountNames(accounts: any[]): string {
    if (!accounts || !Array.isArray(accounts)) return '';
    const names = accounts
      .map(d => d?.account?.name ?? d?.name)
      .filter((name): name is string => typeof name === 'string' && name.trim().length > 0);
    return Array.from(new Set(names)).join(', ');
  }
  //#endregion
}
